/* 
* <license header>
*/

import React from 'react'
import PropTypes from 'prop-types'
import { Outlet, NavLink } from 'react-router-dom'
import AdminControls from './AdminControls'

export default function WebsiteLayout ({ ims }) {
  return (
    <>
      <header className="wv-header">
        <div className="wv-header-inner">
          <div className="wv-title-row">
            <div className="wv-title-accent" aria-hidden />
            <h1 className="wv-title">Vote for the Next Tour City</h1>
          </div>
          {/* <AdminControls ims={ims} /> */}
        </div>
      </header>
      <nav className="wv-nav" aria-label="Vote and summary tabs">
        <NavLink
          to="/website"
          end
          className={({ isActive }) => (isActive ? 'wv-nav-active' : '')}
        >
          Vote for cities
        </NavLink>
        <NavLink
          to="/website/summary"
          className={({ isActive }) => (isActive ? 'wv-nav-active' : '')}
        >
          Summary
        </NavLink>
      </nav>
      <main className="wv-main">
        <Outlet />
      </main>
    </>
  )
}

WebsiteLayout.propTypes = {
  ims: PropTypes.object
}
